import { actions } from '../../../../../../redux/reducers';
import { useDispatch } from "react-redux";
import { SentimentType }  from "../../../../../../types/sentiment";
import ReactECharts from 'echarts-for-react';
import './breakdown-pie.scss';

function BreakdownPie ({
    sentiment,
    loading
} : {
    sentiment: SentimentType[],
    loading: boolean
}){
    const dispatch = useDispatch();
    const outerLegend = ["None", "Positive", "Negative", "Balanced"];
    const innerLegend = ["Owned", "Earned", "Chatter"];
    
    const onClick = async (params: any) => {
        var data = [{}];

        if (params.name == 'Balanced' || params.name === 'Positive' || params.name === 'Negative' || params.name === 'None'){
            var classificationId = getClassificationId(params.name);
            data = sentiment.filter(x => x.ClassificationId === classificationId);
        } else if (params.name === 'Owned' || params.name === 'Earned' || params.name === 'Chatter'){
            var brandAssociationId = getBrandAssociationId(params.name);
            data = sentiment.filter(x => x.BrandAssociationId === brandAssociationId);

            if (brandAssociationId == 3){
                data = data.concat(sentiment.filter(x => x.BrandAssociationId === 0));
            }
        }
        
        if (data.length > 0){
            dispatch(actions.clipTray.set({
                open: true,
                clips: data
            }))
        }
    }

    const getClassificationId = (classification: string) => {
        return {
            'Positive': 3,
            'Negative': 4,
            'Balanced': 5,
            'None': 0,
        } [classification] ;
    }

    const getOuterPieColor = (classification: string) => {
        return {
            'Positive': '#007f0e',
            'Negative': '#c00000',
            'Balanced': '#477bb3',
            'None': '#a0a0a0',
        } [classification] || '';
    }

    const getBrandAssociationId = (brandAssociation: string) => {
        return {
            'Owned': 1,
            'Earned': 2,
            'Chatter': 3
        } [brandAssociation] || '';
    }

    const getInnerPieColor = (brandAssociation: string) => {
        return {
            'Owned': '#639FE3',
            'Earned': '#4BB543',
            'Chatter': '#FF6821'
        } [brandAssociation] || '';
    }

    function getBrandData(content: string[]){
        var data = [{}];
        var filtered;

        content.map((x: string, i: number) => {
            if (x === 'Chatter'){
                var noBrand = sentiment.filter(n => n.BrandAssociationId == 0).length;
                filtered = sentiment.filter(y => y.BrandAssociationId === getBrandAssociationId(x)).length;
                filtered = filtered + noBrand;
            } else {
               filtered = sentiment.filter(y => y.BrandAssociationId === getBrandAssociationId(x)).length;
            }

            data.push(
                {
                    name: x,
                    value: filtered,
                    itemStyle: { color: getInnerPieColor(x)} 
                }
            )
            
        })

        return data;
    }

    function getClassificationData(content: string[]){
        var data = [{}];

        content.map((x: string, i: number) => {

            var filtered = sentiment.filter(y => y.ClassificationId === getClassificationId(x)).length;

            data.push(
                {
                    name: x,
                    value: filtered,
                    itemStyle: { color: getOuterPieColor(x)} 
                }
            )
            
        })

        return data;
    }

    return (
        <div className="breakdown-pie">
            <div className="top">
                <p>Sentiment Breakdown</p>
            </div>
            <div className="body">
                {loading ? 
                <i className="fal fa-spinner fa-spin"></i>
                :
                <ReactECharts
                    option={{
                        tooltip: {
                            formatter: '{a} <br/>{b}: {c} ({d}%)'
                        },
                        legend: [{
                            data: ['Owned', 'Earned', 'Chatter'],
                            margin: 15,
                            x: 'right',
                            top: '25%',
                            orient: 'vertical',
                        },
                        {
                            data: ['None', 'Positive', 'Negative', 'Balanced'],
                            margin: 15,
                            top: 8,
                            x: 'center'
                        }],
                        grid: {
                            left: 30,
                            right: 10,
                            top: 45,
                            bottom: 20
                        },
                        series: [{
                            name: 'Content Classification',
                            type: 'pie',
                            radius: ['0', '30%'],
                            center: ['50%', '60%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'inner'
                            },
                            emphasis: {
                                label: {
                                    show: false,
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: getBrandData(innerLegend)
                        },
                        {
                            name: 'Sentiment Comparison',
                            type: 'pie',
                            radius: ['55%', '75%'],
                            center: ['50%', '60%'],
                            avoidLabelOverlap: true,
                            label: {
                                show: false,
                                position: 'inner'
                            },
                            labelLine: {
                                show: false
                            },
                            data: getClassificationData(outerLegend)
                        }]
                    }}
                    onEvents={{
                        'click': onClick
                    }}
                />
                }
            </div>
        </div>
    )
}

export default BreakdownPie;